import { FormControl, FormHelperText } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FoodsSelect } from "@foodpilot/foods";
import { DataListVersion } from "src/api/sure-api/dataList/useGetAllDataList";
import { formatVersion } from "src/utils/formatting";

interface DataListVersionSelectProps {
    options: DataListVersion[];
    value: DataListVersion | null;
    onChange: (option: DataListVersion | null) => void;
    placeholder?: string;
    disabled?: boolean;
    error?: boolean;
    helperText?: string;
}

export function DataListVersionSelect({
    options,
    value,
    onChange,
    placeholder,
    disabled = false,
    error = false,
    helperText,
}: DataListVersionSelectProps) {
    const { t } = useTranslation();

    return (
        <FormControl fullWidth error={error}>
            <FoodsSelect
                selectedOption={value}
                options={options}
                onChange={(version) => onChange(version ?? null)}
                getId={(version: DataListVersion) => version.id}
                getName={formatVersion}
                closeOnSelect
                disableSearch
                disabled={disabled}
                textOptions={{
                    placeholder:
                        placeholder ||
                        t("settings.data_lists_overrides.data_list.version.placeholder", "Select a data list version"),
                    searchPlaceholder: t("data_list.version.select.searchPlaceholder", "Search versions..."),
                    emptyOptionsText: t("data_list.version.select.noOptions", "No versions available"),
                    defaultValueText: t("data_list.version.select.defaultValue", "Default value"),
                    noResult: t("data_list.version.select.noResultFound", "No versions found"),
                }}
                BoxProps={{ width: "100%" }}
            />
            {helperText ?
                <FormHelperText>{helperText}</FormHelperText>
            :   null}
        </FormControl>
    );
}
